<template>
  <!-- Loading: skeleton of the real results layout, with elapsed time after 3 s -->
  <div v-if="state === 'loading'" class="lx-skel-grid" role="status" aria-live="polite" :aria-label="ariaLoading">
    <div class="d-flex justify-space-between align-center">
      <div class="lx-skel lx-skel--text" style="width: 220px"></div>
      <div class="lx-skel lx-skel--text" style="width: 160px"></div>
    </div>
    <div class="lx-skel lx-skel--chart"></div>
    <div class="lx-skel lx-skel--row"></div>
    <div class="lx-skel lx-skel--row"></div>
    <div class="lx-skel lx-skel--row"></div>
    <div class="lx-elapsed">
      Running the forecast recursion…
      <span v-if="elapsedSeconds != null && elapsedSeconds >= 3">{{ elapsedSeconds }} s elapsed</span>
    </div>
  </div>

  <!-- Error: what failed, what to do next, the raw message for support -->
  <div v-else-if="state === 'error'" class="lx-state lx-state--error" role="alert">
    <span class="lx-state__title">{{ title || "The forecast could not be computed" }}</span>
    <p class="lx-state__msg">{{ message || "The server did not return a result. Your edited assumptions are kept; you can retry, or reload the consensus table." }}</p>
    <pre v-if="detail" class="lx-state__code">{{ detail }}</pre>
    <div class="lx-state__actions">
      <button v-if="retryable" type="button" class="lx-btn lx-btn--primary" @click="$emit('retry')">Retry</button>
      <slot name="actions"></slot>
    </div>
  </div>

  <!-- Partial: results present but an optional block is missing -->
  <div v-else-if="state === 'partial'" class="lx-state lx-state--partial" role="status">
    <span class="lx-state__title">{{ title || "Partial data" }}</span>
    <p class="lx-state__msg">{{ message }}</p>
    <slot name="actions"></slot>
  </div>

  <!-- Empty: nothing to show yet -->
  <div v-else class="lx-empty" role="status">
    <span class="lx-empty__title">{{ title || "No forecast yet" }}</span>
    <span class="lx-empty__hint">{{ message || "Review the consensus assumptions above and click Apply to run the 52-week forecast." }}</span>
    <slot name="actions"></slot>
  </div>
</template>

<script>
export default {
  name: "ForecastStates",
  props: {
    state: { type: String, default: "empty" }, // loading | error | partial | empty
    title: { type: String, default: "" },
    message: { type: String, default: "" },
    detail: { type: String, default: "" },
    elapsedSeconds: { type: Number, default: null },
    retryable: { type: Boolean, default: true },
  },
  emits: ["retry"],
  computed: {
    ariaLoading() {
      return this.elapsedSeconds != null && this.elapsedSeconds >= 3
        ? `Loading forecast, ${this.elapsedSeconds} seconds elapsed`
        : "Loading forecast";
    },
  },
};
</script>
